export const BOOKING_STATUS = {
  PENDING: 0, // At the very start before payment and booking confirmation date
  OPEN: 1, // After payment and booking has been confirmed
  SESSION_STARTED: 2, // Virtual Session has started
  SESSION_COMPLETED: 3, // Virtual Session has been completed
  SESSION_CANCELED: 4, // Virtual Session has been canceled or is unsuccessful
  REPORT_STARTED: 5, // Report is being created
  REPORT_UPLOADED: 6, // Report has been uploaded
  REPORT_SENT: 7, // Report has been sent
  EXPORTED: 8,

  INSPECTION_COMPLETED: 2,
  REPORT_COMPLETED: 5,
};

export const BOOKING_STATUS_LABELS = {
  [BOOKING_STATUS.PENDING]: 'Pending',
  [BOOKING_STATUS.OPEN]: 'Open',
  //[BOOKING_STATUS.SESSION_STARTED]: 'Inspection Started',
  [BOOKING_STATUS.SESSION_COMPLETED]: 'Inspection Completed',
  [BOOKING_STATUS.SESSION_CANCELED]: 'Canceled',
  //[BOOKING_STATUS.REPORT_STARTED]: 'Report Started',
  [BOOKING_STATUS.REPORT_UPLOADED]: 'Report Uploaded',
  [BOOKING_STATUS.REPORT_SENT]: 'Report Sent',

  [BOOKING_STATUS.INSPECTION_COMPLETED]: 'Inspection Completed',
  [BOOKING_STATUS.REPORT_COMPLETED]: 'Report Completed',
  [BOOKING_STATUS.EXPORTED]: 'Exported',
};
